import { isDesktop } from 'init/is-desktop'

/**
 * Стандартный верхний отступ от инициатора.
 * @type {number} - отступ в px.
 */
const COMMON_TOP_MARGIN = 12

/**
 * Выравнивание по центру инициатора,
 * @param {jQuery} $popup
 * @param {jQuery} $opener
 */
export const positionCenterOfOpener = ($popup, $opener) => {
  let openerOffset = $opener.offset() || { left: 0, top: 0 },
    leftOffset = openerOffset.left + $opener.outerWidth() / 2 - $popup.outerWidth() / 2,
    topOffset = openerOffset.top + $opener.innerHeight() + 10,
    css
  if (!isDesktop) {
    let bodyPosition = $('body').position() || { left: 0, top: 0 }
    leftOffset = leftOffset - bodyPosition.left
    topOffset = topOffset - bodyPosition.top
  }
  css = {
    left: leftOffset,
    top: topOffset,
  }
  $popup.css(css)
}

/**
 * Расчитывает положение попапа по левому краю инициатора
 * @param {jQuery} $opener
 * @param {jQuery} $popup
 * @returns {Object} - обьект с позициями слева и сверху от инициатора.
 */
export const positionLeftOfOpener = ($opener, $popup) => {
  const offset = $opener.offset() || { left: 0, top: 0 },
    position = $('body').position() || { left: 0, top: 0 },
    popupWidth = $popup.outerWidth(),
    topPos = offset.top + $opener.innerHeight() + COMMON_TOP_MARGIN,
    windowWidth = $(window).width()
  let leftPos = offset.left

  if (!isDesktop) {
    leftPos = leftPos - position.left
  }
  // если попап слишком далеко от левого края окна, выравниваем его по центру
  if (popupWidth + leftPos > windowWidth) {
    leftPos = (windowWidth - popupWidth) / 2
  }
  return {
    left: leftPos,
    top: topPos,
  }
}

/**
 * Выравнивание по центру окна.
 * @param {jQuery} $popup
 */
export const positionCenterOfWindow = $popup => {
  let css = {
    left: '50%',
    top: '50%',
    'margin-left': -($popup.outerWidth() / 2),
    'margin-top': $(window).scrollTop() - ($popup.outerHeight() / 2),
  }
  $popup.css(css)
}
